import { render, staticRenderFns } from "./PSkillTagListItemFrame.vue?vue&type=template&id=492d45c2&scoped=true&"
import script from "./PSkillTagListItemFrame.vue?vue&type=script&lang=ts&"
export * from "./PSkillTagListItemFrame.vue?vue&type=script&lang=ts&"
import style0 from "./PSkillTagListItemFrame.vue?vue&type=style&index=0&id=492d45c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d45c2",
  null
  
)

export default component.exports